@if (editApplicationJanusView || isCategoryDefinedLayout) {
  <div id="activities" *ngIf="activities">

  <div  class="edit-application-activity-container">
    <div *ngFor="let activity of activities" class="activity-card">
      <!-- HEADER -->
      <div class="edit-activity-header">
        <wm-common-text [data]="{text:activity.summaryLabel}"></wm-common-text>
        <ng-template #editTemplateIcon>
          <wm-common-icon [data]="{iconName:editIcon}"></wm-common-icon>
        </ng-template>
        @if (canEditActivity && activity?.canEdit === true && !(editingJanusActivityId === activity.activityDataId)) {
          <wm-common-button  [data]="onEditIconClick(editTemplateIcon, activity.activityDataId, activity.status === ActivityStatus.InProgress)">
        </wm-common-button>
              }

      </div>
      <!-- COMPLETED INFO -->
      <wm-common-text *ngIf="activity.status === ActivityStatus.Completed" [data]="{
        text:
          'Completed On ' +
          activity.completedOnString +
          ' by ' +
          activity.completedBy
      }">
      </wm-common-text>
      <!-- HISTORY -->
      <div class="mt-2">
        <a href="javascript:void(0)" *ngIf="activity.hasHistory && canEditActivity"
          (click)="viewActivityHistory(activity)">
          History
        </a>
      </div>
      <!-- ACTIVITY VIEW -->
      <!-- edit -->
      @if (editingJanusActivityId === activity.activityDataId) {
      @if (editingActivity) {
      <wm-activity-view [activity]="editingActivity" [form]="activityForm" (goNext)="goNext()" #editActivityInput>
      </wm-activity-view>
      <!-- ACTION BUTTONS -->
      <div class="action-buttons">
        <div class="cancel-button">
        <wm-common-button
        [data]="onCancelButtonClick()"
        ></wm-common-button>
        </div>
        <div class="update-button">
          <ng-template #updateLoaderTemplate>
                    <mat-progress-spinner mode="indeterminate" diameter="20">
                    </mat-progress-spinner>
                </ng-template>
        <wm-common-button
        [data]="onSaveButtonClick(updateLoaderTemplate)"
        ></wm-common-button>
        </div>
      </div>
      }@else {
      <div style="display:flex; justify-content:center; align-items:center; height:100px">
        <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
      </div>
      }



      }@else{
      <!-- readonly -->
      <wm-activity-view  [activity]="activity" [isReadOnly]="true" [form]="form"
        [isPreview]="false">
      </wm-activity-view>
      }

    </div>

    @if (showJanusNotesCard) {
    <div class="activity-card">
      <div class="edit-activity-header mb-2">
        <wm-common-text [data]="{text: 'Notes'}"></wm-common-text>
      </div>

      @if (isLoadingJanusNotes) {
        <div style="padding: 16px; text-align: center;">
          <mat-progress-spinner mode="indeterminate" diameter="24" style="margin: 0 auto;"></mat-progress-spinner>
        </div>
      } @else {
        <wm-application-external-note-editor
          *ngIf="hasExternalNotes && !hasNewExternalNotes"
          [application]="application"
          [readOnly]="true"
          [notesOnly]="true"
        ></wm-application-external-note-editor>

        <div class="janus-readonly-notes-list" *ngIf="hasNewExternalNotes">
           <div *ngFor="let note of janusExternalNotesList" class="janus-readonly-note-item">
              {{ note.note || note.notes || note.externalNotes }}
           </div>
        </div>
      }
    </div>
    }
  </div>
</div>
}@else {
  <div id="activities" *ngIf="activities"  >
  <ul ngbNav [(activeId)]="activeTabId" [destroyOnHide]="false" #tabs="ngbNav" class="nav-tabs"
    [ngClass]="{ 'permit-tabs': templateForPermitForm }" (navChange)="viewActivity($event.nextId)">
    <li *ngFor="let activity of activities" [ngbNavItem]="activity.activityDataId">
      <a ngbNavLink>{{ activity.summaryLabel }}</a>
      <ng-template ngbNavContent>
        <div *ngIf="activity && activity.status === ActivityStatus.Completed">
          <!-- Added by amisha on 24/12/2025 -->
          @if (!templateForPermitForm) {
          <span>
            Completed On {{ activity.completedOnString }} by
            {{ activity.completedBy }}
          </span>
          } @else {
          <wm-common-text [data]="{
              text:
                'Completed On ' +
                activity.completedOnString +
                ' by ' +
                activity.completedBy
            }"></wm-common-text>
          }


          <a href="javascript:void(0)" class="float-right" *ngIf="canEditActivity"
            (click)="editActivity(activity.activityDataId)">Edit Activity</a>


          <a href="javascript:void(0)" class="float-right mr-3" *ngIf="activity.hasHistory && canEditActivity"
            (click)="viewActivityHistory(activity)">History</a>
        </div>

        <app-loader *ngIf="
            activeTabId == activity.activityDataId &&
            !activity.preparedForScreen
          "></app-loader>


        <wm-activity-view [activity]="activity" [isReadOnly]="true" [form]="form" [isPreview]="false" #activityViewItem
          *ngIf="
            activeTabId == activity.activityDataId && activity.preparedForScreen
          "></wm-activity-view>
      </ng-template>
    </li>
    <li *ngIf="application" ngbNavItem="externalNotes">
      <a ngbNavLink>External Notes</a>
      <ng-template ngbNavContent>
        <wm-application-external-note-editor [application]="application"></wm-application-external-note-editor>
        <button class="btn btn-raised btn-success" (click)="saveNotes()" *ngIf="canEditNotes">
          Save Notes
        </button>
      </ng-template>
    </li>
    <li *ngIf="application && canEditNotes" ngbNavItem="internalNotes">
      <a ngbNavLink>Internal Notes</a>
      <ng-template ngbNavContent>
        <ng-container *ngIf="canEditNotes">
          <wm-application-internal-note-editor [application]="application"></wm-application-internal-note-editor>
          <button class="btn btn-raised btn-success" (click)="saveNotes()" *ngIf="canEditNotes">
            Save Notes
          </button>
        </ng-container>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="tabs"></div>
</div>
}


<div class="container">
  <div class="row">
    <div class="col-xs-2">
      <wm-modal-confirm #EditCompletedActivity [showButtonText]="true" [showButton]="false" [buttonText]="'blah'"
        [commandText]="'Update'" [title]="'Update Activity'" (accepted)="updateActivity($event)"
        (canceled)="cancelEdit()" btnColor="danger" class="mx-2" [form]="activityForm" [closeOnAccept]="false">
        <wm-activity-view
          *ngIf="editingActivity && !editApplicationJanusView"
          [activity]="editingActivity"
          [form]="activityForm"
          (goNext)="goNext()"
          #editActivityInput
        ></wm-activity-view>
      </wm-modal-confirm>
      <wm-modal-confirm #ActivityHistory [showButtonText]="false" [showButton]="false" [title]="'Activity History'"
        btnColor="danger" class="mx-2" (canceled)="closeHistory()" (accepted)="closeHistory()">
        <app-loader *ngIf="historyLoading"></app-loader>
        <div class="row" style="width: 100%;margin-left: 0">
          <div class="col-3">Action</div>
          <div class="col-4">Modified By</div>
          <div class="col-5">Modified On</div>
        </div>
        <div ngbAccordion #accordianHistory="ngbAccordion" (shown)="historyExpand($event)" *ngIf="activityHistoryItems">
          <div ngbAccordionItem="{{ h.id }}" *ngFor="let h of activityHistoryItems" [id]="h.id"
            (shown)="expandAudit(h.id)" class="d-flex flex-column h-100">
            <h2 ngbAccordionHeader>
              <button ngbAccordionToggle class="p-0 btn btn-link text-start ps-0">
                <div class="row">
                  <div class="col-3 text-left">{{ h.action }}</div>
                  <div class="col-4 text-left">{{ h.modifiedBy }}</div>
                  <div class="col-5 text-left">{{ h.modifiedOnString }}</div>
                </div>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <app-loader *ngIf="auditLoading[h.id]"></app-loader>
                  <div *ngIf="
                      !auditLoading[h.id] && auditEntityKeys(h.id).length == 0
                    ">
                    Updated but nothing changed
                  </div>
                  <div *ngFor="let k of auditEntityKeys(h.id)">
                    <div class="row">
                      <div class="col text-center de-header">{{ k }}</div>
                    </div>
                    <div class="row">
                      <div class="col de-value-header">Old Value</div>
                    </div>
                    <div class="row">
                      <div class="col align-items-top de-value">
                        <wm-data-entity-view [entity]="auditEntities[h.id][k].oldEntity" [form]="form"
                          [applicationId]="applicationId"></wm-data-entity-view>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col de-value-header">New Value</div>
                    </div>
                    <div class="row">
                      <div class="col align-items-top de-value">
                        <wm-data-entity-view [entity]="auditEntities[h.id][k].newEntity" [form]="form"
                          [applicationId]="applicationId"></wm-data-entity-view>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </wm-modal-confirm>
    </div>
  </div>
</div>
<wm-common-confirmation-modal [data]="underProgressWarningModalData" (onYesClick)="handleUnderProgressWarningModalAccepted()"
    (onNoClick)="handleUnderProgressWarningModalModalRejected()">
</wm-common-confirmation-modal>
